import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        dark: false,
        themes: {
          light: {
            primary: '#000',
            secondary: '#fff',
            accent: '#000',
            success: '#DD2C00',
            error: '#c80570'
          }
        }
      }
});
